import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { getLatestDiary, uniqBy } from 'common/utils';
import { Select } from 'common/components';
import { required } from 'common/form-validators';
import { shortenFormat } from 'common/formatters';
import { ACTIVITY_SIZE } from 'common/constants';

class CropField extends PureComponent {
  // Crop field handling
  handleChangeCrop = target => {
    if (!target) {
      return;
    }
    const { changeValue, clearMarker } = this.props;

    // clear source
    (target.source || []).forEach(
      source => source.result && changeValue(source.result.key, '')
    );
    changeValue('amount', '');
    changeValue('yield', '');
    // clear destinations
    (target.dest || []).forEach(dest => {
      if (dest.result) {
        changeValue(dest.result.key, '');
        changeValue(`${dest.result.key}_amount`, '');
      }
    });
    // clear map pin
    clearMarker();
  };

  render() {
    const {
      submitting,
      disabled,
      options,
      extra = [],
      showVariety,
    } = this.props;

    let cropOption = [];
    if (options.target) {
      cropOption = options.target;

      // expectedYield data comes with target when it's picked from Field
      // when expectedYield data available, exclude the harvested crops
      // but not if the form is disabled (eg editing a historic fertilizing activity)
      if (!disabled) {
        cropOption = cropOption.filter(target => {
          const latestYield = getLatestDiary(target.expectedYield) || {};
          return latestYield.yield
            ? target.crop && !latestYield.yield.harvested
            : target.crop;
        });
      }

      // filter out option that does not have crop,
      // e.g. storage activity may have empty crop prop (null)
      cropOption = cropOption.filter(target => !!target.crop);

      // filter duplicate crop option (same crop, different varieties)
      // when showVariety is set to false
      if (!showVariety) {
        cropOption = uniqBy(cropOption, 'crop.name');

        // clear variety value
        for (let i = 0; i < cropOption.length; i++) {
          if (get(cropOption[i], 'crop.variety')) {
            cropOption[i].crop.variety = '';
          }
        }
      }

      cropOption = cropOption.map(target => {
        const label = shortenFormat(
          `${target.crop.name}${
            target.crop.variety && showVariety ? ' ' + target.crop.variety : ''
          }`,
          ACTIVITY_SIZE.MAX_CROP_TITLE
        );
        const value = JSON.stringify(target.crop);
        return { label, value };
      });

      cropOption = uniqBy(cropOption, 'value');
    }

    if (cropOption) {
      // maybe crop name alphabetical order?
      cropOption.sort((a, b) =>
        a.label < b.label ? -1 : a.label > b.label ? 1 : 0
      );
    }

    // add any extra options
    if (extra.length > 0) {
      cropOption = cropOption.concat(extra);
    }

    return (
      <Select
        name="crop"
        disabled={disabled || submitting}
        title="Crop"
        options={cropOption}
        validate={[required]}
        onChange={() => this.handleChangeCrop(options)}
      />
    );
  }
}

CropField.propTypes = {
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.object,
  changeValue: PropTypes.func.isRequired,
  clearMarker: PropTypes.func.isRequired,
  extra: PropTypes.arrayOf(PropTypes.object),
  showVariety: PropTypes.bool,
};
export default CropField;



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/fields/CropField.js